<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <div>
          <b-card-title class="mb-1">
            Rata-rata Transaksi
          </b-card-title>
        </div>
      </b-card-header>

      <b-card-body>
        <vue-apex-charts
          type="area"
          height="300"
          :options="chartOptions"
          :series="chartData"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCardTitle,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    VueApexCharts,
    BCardHeader,
    BCardBody,
    BCardTitle,
  },
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
    chartOption: {
      type: Object,
      default: () => ({}),
    },
    labelYaxis: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    totalSalesAll() {
      // eslint-disable-next-line radix
      return this.data.reduce((total, el) => total + parseInt(el.external_sales) + parseInt(el.partnered_brand_sales) + parseInt(el.miniapoly_official_store_sales), 0)
    },
    chartData() {
      return [
        {
          name: 'Semua',
          // eslint-disable-next-line radix
          data: this.data.map(el => (el.all_transaction_avg_sales !== null ? parseInt(el.all_transaction_avg_sales) : NaN)),
        },
        {
          name: 'Internal',
          // eslint-disable-next-line radix
          data: this.data.map(el => (el.internal_transaction_avg_sales !== null ? parseInt(el.internal_transaction_avg_sales) : NaN)),
        },
        {
          name: 'Eksternal',
          // eslint-disable-next-line radix
          data: this.data.map(el => (el.external_transaction_avg_sales !== null ? parseInt(el.external_transaction_avg_sales) : NaN)),
        },
      ]
    },
    chartOptions() {
      return {
        ...this.chartOption,
        xaxis: {
          categories: this.data.map(el => this.formatSelectDate(el.date, ['month', 'year'])),
        },
        ...this.labelYaxis,
      }
    },
  },
}
</script>
